var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 251,
    viewBox: "0 0 1440 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M737.5 134.683L1072 26.3715L1312 0L1441 62.6323V251H618L737.5 134.683Z",
    fill: "url(#paint0_linear_271_3900)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M949.5 134.5L1072.5 105.5H1207.5L1349 53L1441 28V251H818L871.5 182.5L949.5 134.5Z",
    fill: "url(#paint1_linear_271_3900)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M767 34.5743L540 8.91089L220.5 0L96.5 34.5743L0 86.2574V252H1102L977.5 117.98L767 34.5743Z",
    fill: "url(#paint2_linear_271_3900)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M338 165.313L214.5 132L135.5 81L51 64L0 45V252H589L463 189.5L338 165.313Z",
    fill: "url(#paint3_linear_271_3900)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_271_3900",
    x1: 1331.5,
    y1: 112.079,
    x2: 552.906,
    y2: 268.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0826295,
    stopColor: "#D2F8E2",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64F5A2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_271_3900",
    x1: 1427.5,
    y1: 235,
    x2: 671.282,
    y2: 310.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0826295,
    stopColor: "#D2F8E2",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.659054,
    stopColor: "#64F5A2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_271_3900",
    x1: 429.5,
    y1: -109.5,
    x2: 1192.04,
    y2: 429.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9FFE0",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEFCEB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_271_3900",
    x1: 25.5,
    y1: 226,
    x2: 560.133,
    y2: 245.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9FFE0",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEFCEB",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterImage);
export default __webpack_public_path__ + "static/media/footer_image.b9e063b5f3dc3682fd36962482a30ffa.svg";
export { ForwardRef as ReactComponent };